const React = require('react');


module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M7 11L0.937823 0.499999L13.0622 0.5L7 11Z"
      />
    </svg>
  );
};
